export const GROUP_COLUMNS = [
  {
    key: "id",
    label: "고유 번호"
  },
  {
    key: "group_name",
    label: "그룹명",
    editType: "input"
  },
  {
    key: "codes",
    label: "관리 대상",
    align: "text-left",
    editType: "custom"
  },
  {
    key: "created_at",
    label: "생성일",
    format: "YYYY-MM-DD"
  },
  {
    key: "updated_at",
    label: "수정일",
    format: "YYYY-MM-DD"
  }
]
